module.exports = __webpack_public_path__ + "img/explosion_thumb.0d6e2e01.jpg";